module.exports = __webpack_public_path__ + "img/bplus-lab.6f524008.png";